import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import close from "../../../assets/img/icons/Vector copy.svg"
import { useAuth } from '../../../context/authContext'
import useFetch from '../../../hooks/useAxios'
import Button from '../../shared/Button'
import Textarea from '../../shared/Textarea'
import UploadImage from '../../shared/UploadImage'
const CommentBoxModal = ({closeModal,inforesidencedetail}) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm();
  const [file, setfile] = useState()
  const {token}=useAuth()
  console.log(token)

  const {slug} = useParams()
  const [postdata, setpostdata] = useState()
  const apipostComment = useFetch({
    method: "post",
    url: `api/residences/${slug}/comment`,
    noHeader: false,
    trigger: false,
    data:postdata,
    formdata:true,
    argFunc:res=>{
      closeModal()
    },
errMessage:(err)=>{
if(err.response.data.message){
toast.error(err.response.data.message);
closeModal()
}
}
   
  });
    const onSubmit =(data)=>{
      const formData = new FormData();
      formData.append("body", data.body);
      if (file) {
        formData.append(
          "image",
          file
         
        );
      }
      setpostdata(formData)
    }
    useEffect(() => {
      if(postdata){
        apipostComment.reFetch()
      }
     
    }, [postdata])
    
  return (
    <div className='ModalBackground'>
        <div className='CommentModal p-[25px] CommentBoxModal'>
         <div className='flex justify-between  items-center'>
           
            <div>
            <h2 className='text-[#292D32] text-[20px] font-[700]'>نظر شما</h2>
            <p className='text-[#797D82] text-[18px] font-[500]'>در مورد {inforesidencedetail.title}</p>
            </div>
             <button onClick={()=>closeModal()}><img src={close}   /></button>
         </div>
         <hr className='my-[20px]'/>
         <form onSubmit={handleSubmit(onSubmit)}>
         <div className='CommentModal__textarea mb-[10px]'>
         <Textarea
          name="body"
          control={control}
          errors={errors}
          className="seconadary-input mt-[8px]"
          rows="5"
          register={{
            required: " آدرس اقامتگاه اجباری است "
          }}
        />
         </div>
         <UploadImage file={file} setfile={setfile} text="اضافه کردن تصویر" id='1'/>
         <hr className='my-[10px]'/>

         <Button varient="primary" fullwidth={true}> ثبت نظر</Button>
         </form>
        </div>
    </div>
  )
}

export default CommentBoxModal